import React from "react"
import StateProvider from "./state/StateProvider"
import Helmet from "react-helmet"
import AuthenticationProvider from "./authentication/AuthenticationProvider"
import CartProvider from "./Cart/CartProvider"
// import ReportingProvider from "./Reporting/ReportingProvider"
import DataProvider from "./Data/DataProvider"
import NotificationProvider from "./Notification/NotificationProvider"
// import LocationProvider from "./Location/LocationProvider"
import { useLocation } from "@reach/router"
import SearchContextProvider from "./Search/searchProvider"
import OnSiteMarketingProvider from "./OnSiteMarketing/OnSiteMarketingProvider"
import {
  scriptGoogleTagManager,
  // scriptStonlyFirst,
  // scriptStonlySecond,
} from "../helpers/ScriptHelper"
import TimeAgo from "javascript-time-ago"
import en from "javascript-time-ago/locale/en.json"
import InventoryProvider from "./Inventory/InventoryProvider"
import ImpersonationBanner from "../components/ImpersonationBanner"
// import Maintenance from "../pages/maintenance"
TimeAgo.addDefaultLocale(en)

const normalizePathname = pathname => {
  if (!pathname || pathname === "/") return "/"
  return pathname.replace(/\/+$/, "")
}

function GlobalProvider({ children }) {
  let location = useLocation()
  const normalizedPathname = normalizePathname(location.pathname)
  const authOnlyRoutes = new Set([
    "/login",
    "/login-sso",
    "/sso-callback",
    "/login_failed",
    "/register",
    "/reset-password",
    "/forgot-password",
  ])

  // if(true) return <Maintenance />

  return (
    <StateProvider>
      <AuthenticationProvider>
        {/* <LocationProvider> */}
        <NotificationProvider>
          {authOnlyRoutes.has(normalizedPathname) ? (
            children
          ) : (
            <DataProvider>
              <InventoryProvider>
                <CartProvider>
                  {/* <ReportingProvider> */}
                  <OnSiteMarketingProvider>
                    <SearchContextProvider>
                      <Helmet>
                        <script>{scriptGoogleTagManager}</script>
                        {/* <script>{scriptStonlyFirst}</script>
                          <script>{scriptStonlySecond}</script> */}
                      </Helmet>
                      {children}
                    </SearchContextProvider>
                  </OnSiteMarketingProvider>
                  {/* </ReportingProvider> */}
                </CartProvider>
              </InventoryProvider>
            </DataProvider>
          )}
        </NotificationProvider>
        {/* </LocationProvider> */}
        <ImpersonationBanner />
      </AuthenticationProvider>
    </StateProvider>
  )
}

export default GlobalProvider
